export default {
  'code[class*="language-"]': {
    color: 'white',
    background: 'none',
    fontFamily: "'Andale Mono', 'Ubuntu Mono', monospace",
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    wordWrap: 'normal',
    lineHeight: '1.5',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
  },
  'pre[class*="language-"]': {
    color: '#fff',
    background: '#131519',
    fontFamily: "'Andale Mono', 'Ubuntu Mono', monospace",
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    wordWrap: 'normal',
    lineHeight: '1.5',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
    padding: '20px 30px',
    margin: '.5em 0',
    overflow: 'auto',
  },
  ':not(pre) > code[class*="language-"]': {
    background: '#131519',
    padding: '.1em',
    borderRadius: '.3em',
    whiteSpace: 'normal',
  },
  comment: {
    color: '#999',
  },
  'block-comment': {
    color: '#999',
  },
  prolog: {
    color: '#999',
  },
  doctype: {
    color: '#999',
  },
  cdata: {
    color: '#999',
  },
  punctuation: {
    color: '#ccc',
  },
  tag: {
    color: '#A7B7DE',
  },
  'attr-name': {
    color: '#A7B7DE',
  },
  namespace: {
    color: '#A7B7DE',
  },
  deleted: {
    color: '#A7B7DE',
  },
  'function-name': {
    color: '#6196cc',
  },
  boolean: {
    color: '#f08d49',
  },
  number: {
    color: '#f08d49',
  },
  function: {
    color: '#f08d49',
  },
  property: {
    color: '#f8c555',
  },
  'class-name': {
    color: '#f8c555',
  },
  constant: {
    color: '#f8c555',
  },
  symbol: {
    color: '#f8c555',
  },
  selector: {
    color: '#A7B7DE',
  },
  important: {
    color: '#A7B7DE',
    fontWeight: 'bold',
  },
  atrule: {
    color: '#A7B7DE',
  },
  keyword: {
    color: '#A7B7DE',
  },
  builtin: {
    color: '#A7B7DE',
  },
  string: {
    color: '#FFAE52',
  },
  char: {
    color: '#FFAE52',
  },
  'attr-value': {
    color: '#FFAE52',
  },
  regex: {
    color: '#FFAE52',
  },
  variable: {
    color: '#FFAE52',
  },
  operator: {
    color: '#67cdcc',
  },
  entity: {
    color: '#67cdcc',
    cursor: 'help',
  },
  url: {
    color: '#67cdcc',
  },
  bold: {
    fontWeight: 'bold',
  },
  italic: {
    fontStyle: 'italic',
  },
  inserted: {
    color: 'green',
  },
}
